module.exports = __webpack_public_path__ + "media/images/weather/31_night-6c81b69aa9e670960dc7baaf7b137dac.png";